import React, { useEffect } from "react";
import ComponentMenu from "../../components/layout/ComponentMenu";
// import ComponentOffre from "../../components/public/offre/ComponentOffre";
import ComponentVisualManagement from "../../components/public/media/ComponentVisualManagement";
import { Container, Image } from "react-bootstrap";
import { apiUpdateUserByIdColidee } from "../../api/ApiUser";
import { useSelector } from "react-redux";

import BlocEpingleStats from "../../components/public/home/BlocEpingleStats";
import BlocEpingleEspace from "../../components/public/home/BlocEpingle1";
import BlocEpingleEvenementsActeurs from "../../components/public/home/BlocEpingle2";
import BlocEpingleMissions from "../../components/public/home/BlocEpingle3";
import BlocEpingleActualitesPublicationsEmissions from "../../components/public/home/BlocEpingle4";
import BlocNotifications from "../../components/public/home/BlocEpingleNotif";
import BlocStories from "../../components/public/home/BlocStories";

import hackHomeEthics from "../../assets/images/hackHomeEthics.png";

const PageHome = () => {
  const { ReduxUserIdColidee } = useSelector((state) => state.ReduxUser);
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);

  useEffect(() => {
    if (ReduxUserIdColidee) {
      apiUpdateUserByIdColidee(ReduxUserIdColidee, { derniereVisite: Date.now() });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentMenu menuActif="home" />
      {ReduxInstance._id === "61d451a3cfbe1247a76bbaa3" && (
        <div className="hackHomeEthics">{/* <Image src={hackHomeEthics} /> */}</div>
      )}

      <Container className="mb-5">
        <BlocEpingleStats />
        <BlocNotifications />
        <BlocStories />
        <BlocEpingleMissions />
        <BlocEpingleActualitesPublicationsEmissions />
        <BlocEpingleEvenementsActeurs />
        <BlocEpingleEspace />
        {/* <ComponentOffre /> */}
        <ComponentVisualManagement />
      </Container>
    </>
  );
};

export default PageHome;
